import { cardItems } from '@/mocks/home';

export default function SectionCards() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              内容分类
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {cardItems.map((item) => (
              <a
                key={item.id}
                href="#cards"
                className="group bg-background-50 rounded-xl border border-background-200/60 hover:border-accent-200 transition-all duration-300 overflow-hidden cursor-pointer"
              >
                <div className="aspect-[3/2] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-2.5 mb-2">
                    <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center">
                      <i className={`${item.icon} text-accent-600 text-base`}></i>
                    </div>
                    <h3 className="font-heading text-base font-semibold text-foreground-900">
                      {item.title}
                    </h3>
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                    {item.desc}
                  </p>
                  <span className="text-xs font-medium text-primary-500">
                    {item.count} 部资源
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}